import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { CityProvider, useCityContext } from './contexts/CityContext';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import HomePage from './pages/HomePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AddVenuePage from './pages/AddVenuePage';
import EditVenuePage from './pages/EditVenuePage';
import SingleVenuePage from './pages/SingleVenuePage';
import { useGTM } from './hooks/useGTM';

// Create a wrapper component that uses GTM and sets document title
const AppContent = () => {
  useGTM();
  const { city } = useCityContext();

  // Set document title based on city
  useEffect(() => {
    document.title = `${city.displayName} - ${city.tagline}`;
  }, [city]);

  return (
    <Routes>
      {/* Public routes - city determined by hostname */}
      <Route path="/" element={<HomePage />} />
      <Route path="/venue/:venueId" element={<SingleVenuePage />} />

      {/* Admin routes (global, shared across all cities) */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route element={<ProtectedAdminRoute />}>
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/venues/new" element={<AddVenuePage />} />
        <Route path="/admin/venues/edit/:venueId" element={<EditVenuePage />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <CityProvider>
      <AdminAuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AdminAuthProvider>
    </CityProvider>
  );
}

export default App;
